import { matchPath } from 'react-router-dom';

import {
  DefaultOnboardingRoutes,
  signInOnboardingExtraPaths,
  signInOnboardingPaths,
} from 'apps/customer/routes/paths';

import type { SignInOnboardingExperimentState } from 'apps/customer/containers/Onboarding/container/useSignInOnboardingExperiment';

export function isSignInOnboardingPath(pathname: string): boolean {
  return signInOnboardingPaths.some((path) => !!matchPath(pathname, { path, exact: true }));
}

export function isOnTreatmentSignInOnboardingPath({
  experiment,
  pathname,
}: {
  experiment: SignInOnboardingExperimentState;
  pathname: string;
}): boolean {
  return experiment.status === 'treatment' && isSignInOnboardingPath(pathname);
}

export function isTreatmentOnlySignInOnboardingPath(pathname: string): boolean {
  return [DefaultOnboardingRoutes.AddEmail, ...signInOnboardingExtraPaths].some(
    (path) => !!matchPath(pathname, { path, exact: true }),
  );
}
